import callApi from 'lib/callApi';

export async function fetchReportDetail(id, companyId) {
  let url = `reports/${id}/?company_id=${companyId}`;
  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}
